import { Blueprint, Blueprints } from '@leverege/api-attributes'
import { Relationships } from '@leverege/ui-attributes'
import { BlueprintAnalyzer } from '@leverege/molten/imagine'
import { Plugins } from '@leverege/plugin'
import RelationshipAnalyzer from './RelationshipAnalyzer'

async function run( api, projectId, options ) {

  const list = await api.project( projectId ).blueprints().list( { children : 'attribute', attribute : { perPage : 1000 } } )
  const blueprints = new Map()
  const bps = list.items.map( ( model ) => { 
    const bp = new Blueprint( model, { blueprints } ) 
    blueprints.set( bp.id, bp ) // look up by id
    blueprints.set( bp.type, bp ) // look up by alias if available
    return bp
  } )

  const analyzer = new BlueprintAnalyzer( {
    molten : {
      getConfig() {
        return null
      },
      getDefault() {

      },
      addPlugin : ( ...rest ) => Plugins.addPlugin( ...rest )
    },
    blueprints : bps }
  )

  await analyzer.install()

  Blueprints.set( bps )

  Relationships.clear()
  await RelationshipAnalyzer.run( {}, bps )
}

export default {
  run
}
